<app-dialog-header [title]="'PAGE.CERTIFICATIONS.LABEL.FILTER_BY_CERTIFICATIONS'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <ng-container *ngIf="selectedTags.length">
        <h3 class="mb-16 mt-0 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED' | translate }}:</h3>
        <mat-chip-set class="chip-list wrap">
            <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="onTagRemove(item)" *ngFor="let item of selectedTags">
                {{ item.text }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-12 mt-24">
        <app-search-outline [searchInput]="searchInput"></app-search-outline>
    </div>

    <div class="w-100-p table-wrapper" *ngIf="dataSource && !selectedProvider" [class.hidden]="isCertificationProvidersLoading">
        <mat-table #table [dataSource]="dataSource">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="checkbox">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let provider">
                    <mat-checkbox [(ngModel)]="checkboxes[provider.id]" (ngModelChange)="toggleProviderSelection(provider)" (click)="$event.stopPropagation()"> </mat-checkbox>
                </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="ml-16" *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let provider" class="ml-16">
                    <p #firstNameRow class="text-truncate">
                        {{ provider.providerName }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let provider">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <p
                            class="text-sm font-normal text-gray-500 mr-12 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                            [class.group-hover:!opacity-0]="isActionBoxHovered"
                        >
                            {{ 'GENERAL.LABEL.SEE_CERTIFICATIONS' | translate }}
                        </p>
                        <mat-icon class="icon-18 duration-300"> arrow_forward_ios </mat-icon>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let provider; columns: displayedColumns" class="relative group pointer hover:bg-gray-50" matRipple (click)="showCertifications(provider)">
            </mat-row>
        </mat-table>
    </div>

    <div class="w-100-p certifications-table-wrapper" *ngIf="certificationsDataSource && selectedProvider" [class.hidden]="isCertificationsLoading">
        <div class="h-[58px] pl-[21px] pr-[59px] bg-lightgreybackground border-b border-b-[#E0E0E0]" fxLayoutAlign="space-between center">
            <div fxLayoutAlign="flex-start center">
                <mat-icon class="mr-16 back-icon" svgIcon="left_chevron" (click)="goBackToProviders()"></mat-icon>
                <div>{{ selectedProvider.providerName }}</div>
            </div>
            <mat-checkbox
                [(ngModel)]="checkboxes[selectedProvider.id]"
                (ngModelChange)="toggleProviderSelection(selectedProvider, true)"
                (click)="$event.stopPropagation()"
            ></mat-checkbox>
        </div>
        <mat-table #table [dataSource]="certificationsDataSource">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="ml-16" *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let certification" class="ml-16">
                    <p #firstNameRow class="text-truncate">
                        {{ certification.certificationName }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Checkbox Column -->
            <ng-container matColumnDef="checkbox">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let certification">
                    <mat-checkbox
                        [(ngModel)]="certificationCheckboxes[certification.id]"
                        (ngModelChange)="toggleCertificationSelection(certification)"
                        (click)="$event.stopPropagation()"
                    >
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="certificationsDisplayedColumns"></mat-header-row>
            <mat-row *matRowDef="let certification; columns: certificationsDisplayedColumns" class="relative pointer" matRipple> </mat-row>
        </mat-table>
    </div>

    <div
        class="shimmer-container p-0 mt-32"
        fxLayout="column"
        fxLayoutAlign="space-between flex-start"
        fxLayoutGap="16px"
        *ngIf="isCertificationsLoading || isCertificationProvidersLoading"
    >
        <div class="shimmer w-100-p">
            <div class="shimmer-card module animate"></div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button class="mr-8" [label]="'GENERAL.LABEL.CLEAR_SELECTION'" (onClick)="clearSelection()"></app-white-button>
    <div fxLayout="row" fxLayoutAlign="end center">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
        <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="saveSelected()"></app-flat-button>
    </div>
</div>
